import { memo, FC, SVGProps } from "react"

export const ArrowsClockwiseIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M13.125 7.5H16.875V3.75" />
    <path d="M16.875 7.49636L14.6656 5.28699C13.3861 4.00753 11.6538 3.28408 9.84437 3.27355C8.03494 3.26302 6.29431 3.96626 5 5.23074" />
    <path d="M6.875 12.5H3.125V16.25" />
    <path d="M3.125 12.5L5.33437 14.7094C6.61388 15.9888 8.34621 16.7123 10.1556 16.7228C11.9651 16.7333 13.7057 16.0301 15 14.7656" />
  </svg>
))
export default ArrowsClockwiseIcon
